import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthClassicLockScreen() {
	return <AuthShell variant="classic"><AuthForm variant="classic" mode="lock-screen" /></AuthShell>;
}

export default AuthClassicLockScreen;
